import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';

export interface WorkflowAccessState {
  kind: 'checking' | 'retry' | 'changed';
  message?: string;
}

interface WorkflowAccessDialogProps {
  open: boolean;
  status: WorkflowAccessState | null;
  onLeave: () => void;
  onRetry: () => void;
}

const titles = {
  checking: 'Checking workflow access',
  retry: 'Could not verify workflow',
  changed: 'Workflow changed',
};

export default function WorkflowAccessDialog({
  open, status, onLeave, onRetry,
}: WorkflowAccessDialogProps) {
  const canRetry = status?.kind === 'retry' || status?.kind === 'changed';
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      aria-labelledby="flow-revalidation-title"
      aria-describedby="flow-revalidation-description"
      sx={{ zIndex: 3000 }}
      BackdropProps={{ sx: { backgroundColor: 'background.default' } }}
    >
      <DialogTitle id="flow-revalidation-title">
        {titles[status?.kind ?? 'checking']}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="flow-revalidation-description">
          {status?.message ?? 'Checking the current role permissions and workflow stage path. Your in-progress work stays open while this check completes.'}
        </DialogContentText>
      </DialogContent>
      {canRetry && (
        <DialogActions>
          <Button onClick={onLeave}>Leave workflow</Button>
          <Button variant="contained" onClick={onRetry}>Retry</Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
